import { Skeleton } from "@mui/material"
import { CustomBlocSkeleton } from "./styles"

export default function BlocSkeleton({ totalSkeleton, width }) {
    return (
        <CustomBlocSkeleton
            inputCssProps={{
                $width: width,
            }}
            data-testid="custom-bloc-skeleton"
        >
            {[...Array(totalSkeleton).keys()].map((x) => (
                <Skeleton key={x} animation={false} data-testid="skeleton-element" />
            ))}
        </CustomBlocSkeleton>
    )
}
